import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, BookOpen } from "lucide-react";
import knowledgeService from "../services/knowledgeService";

// Cabeçalho público simples (sem sidebar/login).
const PublicHeader = () => (
  <header className="border-b border-gray-200 bg-white">
    <div className="mx-auto flex max-w-4xl items-center gap-2 px-4 py-4">
      <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 font-bold text-white">B</span>
      <span className="text-lg font-extrabold text-gray-900">BenDesk</span>
      <span className="ml-2 text-sm text-gray-500">Central de Ajuda</span>
    </div>
  </header>
);

const KBPublica = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setLoading(true);
    knowledgeService
      .listPublic({ q: search || undefined })
      .then((d) => setArticles(Array.isArray(d) ? d : []))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, [search]);

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <main className="mx-auto max-w-4xl px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900">Base de Conhecimento</h1>
        <p className="text-gray-500">Artigos de autoatendimento. Não achou? Abra um chamado com a TI.</p>

        <div className="relative mt-5">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar artigos..."
            className="w-full rounded-md border border-gray-300 bg-white pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {loading ? (
          <div className="py-16 text-center text-gray-500">Carregando...</div>
        ) : articles.length === 0 ? (
          <div className="py-16 text-center text-gray-500">
            <BookOpen className="mx-auto mb-3 h-8 w-8 text-gray-300" />
            Nenhum artigo publicado.
          </div>
        ) : (
          <div className="mt-5 space-y-3">
            {articles.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => navigate(`/kb/${a.id}`)}
                className="block w-full rounded-lg border border-gray-200 bg-white p-4 text-left transition-shadow hover:shadow-md"
              >
                {a.category && (
                  <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">{a.category}</span>
                )}
                <h3 className="mt-1 font-semibold text-gray-900">{a.title}</h3>
                {a.snippet && <p className="mt-1 text-sm text-gray-500 line-clamp-2">{a.snippet}</p>}
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default KBPublica;
